<ng-container *ngIf="bundled">
  <div class="pl-centered-section credential-list-container" [ngStyle]="{ height: expanded ? 'initial' : 0 }">
    <div class="pl-subsection--background credential-list-header">
      <se-org-avatar
        se-data-size="200"
        se-data-identity="{{ orgName }}"
        se-data-img-url="{{ orgLogo.is_default ? '' : orgLogo.url }}">
      </se-org-avatar>
      <span>Managed By {{ orgName }}</span>
    </div>
    <div *ngFor="let credentialItem of credentialItems" class="se-app__content-separated">
      <app-verify-credential-item [credentialItem]="credentialItem" [expanded]="expanded"></app-verify-credential-item>
    </div>
  </div>
</ng-container>
<div *ngIf="!bundled" class="credential-list-container">
  <div *ngFor="let credentialItem of credentialItems" class="se-app__content-separated condensed">
    <app-verify-credential-item [credentialItem]="credentialItem" [expanded]="expanded"></app-verify-credential-item>
  </div>
</div>
